import { mergeAttributes, Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import Component from "./ImagePlaceholder";
export default Node.create({
  name: "imagePlaceholder",
  group: "block",

  atom: true,

  addAttributes() {
    return {
      type: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-type"),
        renderHTML: (attributes) => {
          if (!attributes.type) return {};
          return { "data-type": attributes.type };
        },
      },
      name: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-name"),
        renderHTML: (attributes) => {
          if (!attributes.name) return {};
          return { "data-name": attributes.name };
        },
      },
      width: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-width"),
        renderHTML: (attributes) => {
          if (!attributes.width) return {};
          return { "data-width": attributes.width };
        },
      },
      height: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-height"),
        renderHTML: (attributes) => {
          if (!attributes.height) return {};
          return { "data-height": attributes.height };
        },
      },
      "data-placeholder-id": {
        default: "",
        parseHTML: (element) => element.getAttribute("data-placeholder-id"),
        renderHTML: (attributes) => {
          if (!attributes["data-placeholder-id"]) return {};
          return { "data-placeholder-id": attributes["data-placeholder-id"] };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-type='image-placeholder']",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, { "data-type": "image-placeholder" }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});
